import OnBoardingTooltip from 'components/OnBoardingTooltip';
import { useEffect, useState } from 'react';
import Joyride, { CallBackProps, STATUS, Step } from 'react-joyride';
import useOnboarding from 'store/useOnboarding';
import { Page, State } from './Onboarding.types';
export default function Onboarding({
  steps,
  page,
}: {
  steps: Step[];
  page: Page;
}) {
  const { completedPages, addPage } = useOnboarding();
  const [onboardingState, setOnboarding] = useState<State>({
    run: false,
    complete: false,
    steps: [],
  });

  useEffect(() => {
    if (onboardingState.complete) {
      // navigate(0);
      addPage(page);
    }
    // eslint-disable-next-line
  }, [onboardingState.complete, addPage, page]);

  useEffect(() => {
    const id = setTimeout(() => {
      if (!completedPages.includes(page)) {
        setOnboarding((prevState) => ({
          ...prevState,
          steps,
          run: true,
        }));
      }
    }, 1000);
    return () => clearTimeout(id);
    // eslint-disable-next-line
  }, [addPage, page, completedPages, steps]);

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status } = data;
    const options: string[] = [STATUS.FINISHED, STATUS.SKIPPED];

    if (options.includes(status)) {
      setOnboarding((prevState) => ({
        ...prevState,
        complete: true,
        run: false,
      }));
    }
  };
  return (
    <Joyride
      callback={handleJoyrideCallback}
      continuous
      run={onboardingState.run}
      scrollToFirstStep={false}
      showProgress
      showSkipButton
      steps={onboardingState.steps}
      tooltipComponent={OnBoardingTooltip}
      styles={{
        options: {
          zIndex: 2000000,
        },
        overlay: {
          backgroundColor: 'rgba(22, 31, 33, 1)',
        },
      }}
    />
  );
}
